var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog-big",
      attrs: { visible: _vm.visible, "close-on-click-modal": true, top: "5px" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeForm,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("span", { staticClass: "el-dialog__title" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("common.one_off")) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.submitting,
              expression: "submitting",
            },
          ],
        },
        [
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.active,
                "finish-status": "success",
                "align-center": "",
              },
            },
            [
              _c("el-step", {
                attrs: { title: "Customer", description: "Details" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Product", description: "Details" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Extra", description: "Information" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Review", description: "Before submit" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "Summary", description: "request" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-content" }, [
            _vm.active === 0
              ? _c(
                  "div",
                  [
                    _vm.visible
                      ? _c("customer-request-customer-step", {
                          ref: "customerStep",
                          on: {
                            next: function ($event) {
                              return _vm.nextStep(1)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 1
              ? _c(
                  "div",
                  [
                    _c("customer-request-product-step", {
                      on: {
                        back: function ($event) {
                          return _vm.backStep(0)
                        },
                        next: function ($event) {
                          return _vm.nextStep(2)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 2
              ? _c(
                  "div",
                  [
                    _c("customer-request-misc-step", {
                      on: {
                        back: function ($event) {
                          return _vm.backStep(1)
                        },
                        next: function ($event) {
                          return _vm.nextStep(3)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 3
              ? _c(
                  "div",
                  [
                    _c("customer-request-review-step", {
                      on: {
                        back: function ($event) {
                          return _vm.backStep(2)
                        },
                        submit: function ($event) {
                          return _vm.submit()
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 4
              ? _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("h4", { staticClass: "request-panel-title" }, [
                              _vm._v("\n              Request\n            "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Request ID")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.uuid) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("State")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.state) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Product")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.newRequest.product.description
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Agent")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.agent.email) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Reasons")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _c(
                                    "ul",
                                    { staticClass: "reasons-resume" },
                                    _vm._l(
                                      _vm.newRequest.request_reasons,
                                      function (rr) {
                                        return _c(
                                          "li",
                                          {
                                            key:
                                              rr.reason.id ||
                                              rr.reason.table.reason_id,
                                            staticClass: "reason-row",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  rr.reason.text ||
                                                    rr.reason.table.text
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Created")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("time-zone-formatter", {
                                      attrs: {
                                        "current-time":
                                          _vm.newRequest.created_at,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("h4", { staticClass: "request-panel-title" }, [
                              _vm._v("\n              Customer\n            "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Name")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_name) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Email")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_email) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Phone")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_phone) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticClass: "form-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("b", [_vm._v("Address")]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 18 } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.newRequest.customer_address_1
                                      ) +
                                      ",\n                "
                                  ),
                                  _vm.newRequest.customer_address_2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.newRequest.customer_address_2
                                          ) + ","
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_city) +
                                      "\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newRequest.customer_zip) +
                                      ",\n                " +
                                      _vm._s(_vm.newRequest.customer_state) +
                                      ",\n                " +
                                      _vm._s(_vm.newRequest.customer_country) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "center-buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.closeForm()
                              },
                            },
                          },
                          [_vm._v("\n            Finish\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.showCopyModal()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Copy Request Information\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("CustomerRequestCopyData", {
                      ref: "copyRequestModal",
                      attrs: { request: _vm.newRequest },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }